import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiCashFlow from '../../Api/ApiCashFlow';
import ToastMsg from '../../Components/ToastMsg';
import { creators as CashFlowActions } from '../../Reducers/Reporting/CashFlow';

export function* getTopData({ payload }) {
  try {
    const response = yield call(ApiCashFlow.getTop, payload.selectedYears);
    if (response.status === 200) {
      yield put(CashFlowActions.cashflowSuccess({ topData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data : {
            title: "CashFlow Top Chart",
            text: response.message,
          },
        },
      );
      yield put(CashFlowActions.cashflowFailure(response.message));
    }
  } catch (e) {
    yield put(CashFlowActions.cashflowFailure(e));
  }
}

export function* getMiddleData({ payload }) {
  try {
    const response = yield call(ApiCashFlow.getMiddle, payload.dimDate);
    if (response.status === 200) {
      yield put(CashFlowActions.cashflowSuccess({ middleData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data : {
            title: "CashFlow Middle Chart",
            text: response.message,
          },
        },
      );
      yield put(CashFlowActions.cashflowFailure(response.message));
    }
  } catch (e) {
    yield put(CashFlowActions.cashflowFailure(e));
  }
}

export function* getBottomData({ payload }) {
  try {
    const response = yield call(ApiCashFlow.getBottom, payload.selectedYears);
    if (response.status === 200) {
      yield put(CashFlowActions.cashflowSuccess({ bottomData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data : {
            title: "CashFlow Bottom Chart",
            text: response.message,
          },
        },
      );
      yield put(CashFlowActions.cashflowFailure(response.message));
    }
  } catch (e) {
    yield put(CashFlowActions.cashflowFailure(e));
  }
}
